import { ClientFormData } from '@/types/clients/ClientFormData';
import { ClientResponse } from '@/types/clients/ClientResponse';

export const loadClientData = (client: ClientResponse): ClientFormData => ({
  agencyName: client.agencyName ?? undefined,
  mainContact: {
    firstName: client.mainContact.firstName,
    lastName: client.mainContact.lastName,
    email: client.mainContact.email ?? undefined,
    phoneNumber: client.mainContact.phoneNumber ?? undefined,
  },
  secondaryContacts: client.contacts.map((contact) => ({
    firstName: contact.firstName,
    lastName: contact.lastName,
    email: contact.email ?? undefined,
    phoneNumber: contact.phoneNumber ?? undefined,
  })),
  address: client.address ?? undefined,
  city: client.city ?? undefined,
  postalCode: client.postalCode ? Number(client.postalCode) : undefined,
  country: client.country
    ? {
        value: client.country,
        label: client.country,
      }
    : undefined,
  marginRate: client.marginRate ?? undefined,
  reservationAgent: {
    value: client.reservationAgent.id,
    label: `${client.reservationAgent.firstname} ${client.reservationAgent.lastname}`,
  },
});
